import { matchPath } from 'react-router-dom'
import routes from './routes'

export const getPageRoute = async path => {
  const route = routes.find(route => matchPath(path, route))
  const page = await Promise.resolve(route.component.load ? route.component.load() : route.component)
  return { route, page }
}

// Unwraps a lazy page to its module, whose exports carry getInitialActions and asyncStores.
export const resolvePageModule = async page => {
  if (typeof page._payload?._result === 'function') {
    return page._payload._result()
  }
  if (page._payload) {
    return page._payload._result
  }
  return page
}

export default getPageRoute
